var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7299 24.7959C15.3611 24.7959 15.8678 24.5426 16.4788 23.9709L25.7544 15.2552C26.2103 14.8249 26.3859 14.3248 26.3859 13.898C26.3859 13.4531 26.222 12.9731 25.7566 12.5332L16.4788 3.88476C15.805 3.25453 15.3719 3 14.7491 3C13.8276 3 13.1531 3.72258 13.1531 4.6153V8.8193H12.8617C4.73547 8.8193 1 14.0424 1 22.5591C1 23.9909 1.62062 24.7474 2.43062 24.7474C3.03038 24.7474 3.60952 24.5627 4.06397 23.7157C5.91741 20.2528 8.55648 19.0052 12.8617 19.0052H13.1531V23.2308C13.1531 24.1235 13.8276 24.7959 14.7299 24.7959Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a883a1192304ab3d68d84df989833012.svg";
export { ForwardRef as ReactComponent };